import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 17.8.",
  "description": "",
  "published": "2011-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-17-8/swizec/2244"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/Screen-Shot-2011-08-17-at-9.25.35-PM-300x234.png",
        "alt": null,
        "title": "Daily stats"
      }}></img></p>
    <p>{`Today I learned that apparently people really love going on the internet to read about some dumb guy who has decided to severely limit his internet usage almost to the point of considering it being completely offline when compared to his previous habits. There was a great deal of tweeting my yesterday's blogpost about how `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/my-ideas-are-shitty-so-im-going-on-an-internet-diet/swizec/2239",
        "title": "My ideas are shitty so I’m going on an internet diet"
      }}>{`my ideas are shit and I'm going on an internet diet`}</a>{`.`}</p>
    <p>{`There were also 127 upvotes on hackernews and 80+ comments. The only time something like that has happened on my blog before was when `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/apples-ping-is-a-big-pile-of-steaming-dung/swizec/1444",
        "title": "Apple’s Ping is a big pile of steaming dung"
      }}>{`I pissed all over Apple's Ping`}</a>{`.`}</p>
    <p>{`I also learned that apparently through some fluke or stupidity neither google analytics nor mixpanel were loading on the blog all day. Therefore I have no proper way of telling how many people read that post and what's most unfortunate, my mixpanel tracking of how far people scroll down my page ...`}</p>
    <p>{`But! My cool sysadmin has a stats thing and from what I can tell, there were 20,000 people or thereabouts reading the blog yesterday. This is particularly epic since my goal for this year is to build the blog up so much I have 20k monthly visitors. :D`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      